module.exports = __webpack_public_path__ + "media/do.6cddc940.mp4";